import { render, staticRenderFns } from "./TabelaColaboradores.vue?vue&type=template&id=35ddb875&scoped=true"
import script from "./TabelaColaboradores.vue?vue&type=script&lang=js"
export * from "./TabelaColaboradores.vue?vue&type=script&lang=js"
import style0 from "./TabelaColaboradores.vue?vue&type=style&index=0&id=35ddb875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddb875",
  null
  
)

export default component.exports